import { useSelector } from 'react-redux';
import { Table } from '@quintoandar-tokko/jopijs';
import AgentsPerformanceTableRow from './AgentsPerformanceTableRow';

export default function AgentsPerformanceNonGroupedTableContent() {
  const { agentsPerformance } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );

  return (
    <Table.Rows>
      {agentsPerformance.list.map((row, index) => (
        // eslint-disable-next-line
        <AgentsPerformanceTableRow key={index} row={row} />
      ))}
    </Table.Rows>
  );
}
